"use client";

import { useRef } from "react";
import { cn } from "@/lib/utils/cn";
import { FUND_CATEGORIES } from "@/lib/utils/fund-categories";

type FundCategoryChipsProps = {
  activeCategory: string | null;
  onSelect: (category: string | null) => void;
};

export function FundCategoryChips({
  activeCategory,
  onSelect,
}: FundCategoryChipsProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={scrollRef}
      className="flex gap-2 overflow-x-auto pb-2 scrollbar-none"
      style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
    >
      {/* "All" chip */}
      <button
        onClick={() => onSelect(null)}
        className={cn(
          "shrink-0 px-3 py-1.5 rounded-full text-xs font-medium transition cursor-pointer border-none whitespace-nowrap",
          activeCategory === null
            ? "bg-blue text-white"
            : "bg-navy-mid text-muted-foreground hover:text-foreground"
        )}
      >
        All
      </button>

      {FUND_CATEGORIES.map((cat) => (
        <button
          key={cat.key}
          onClick={() => onSelect(cat.key)}
          className={cn(
            "shrink-0 px-3 py-1.5 rounded-full text-xs font-medium transition cursor-pointer border-none whitespace-nowrap",
            activeCategory === cat.key
              ? "bg-blue text-white"
              : "bg-navy-mid text-muted-foreground hover:text-foreground"
          )}
        >
          {cat.label}
        </button>
      ))}
    </div>
  );
}
